/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date: Tue Nov 07 2023 14:30:30
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Icon, Button, Link } from '@shopify/polaris';
import { CancelSmallMinor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { getShop } from 'src/helpers';
import { URL } from 'src/constants/links';

type Props = {
  onDismiss: Function,
  host: string
};

type ComposedProps = Props & WithI18nProps;

type State = {
  dismissedBanner: boolean
};

class HowToUse extends Component<ComposedProps, State> {
  state = {
    dismissedBanner: false
  };

  componentDidMount() {
    // Hide banner
    this.checkDismissedBanner();
  }

  render() {
    // const { onDismiss } = this.props;
    const { dismissedBanner } = this.state;
    const { i18n } = this.props;

    return !dismissedBanner ? (
      <div className="general-settings-banner">
        <div className="banner-left">
          <div className="banner-content">
            <div>
              <span className="banner-title">
                {i18n.translate('AdminHTML.Recommendation.GeneralSettings.HowToUse.bannerTitle')}
              </span>
            </div>
            <span className="banner-content-body">
              {i18n.translate('AdminHTML.Recommendation.GeneralSettings.HowToUse.content')}
            </span>
            <p className="banner-content-body" style={{ marginTop: '8px' }}>
              {i18n.translate('AdminHTML.Recommendation.GeneralSettings.HowToUse.content01')}
            </p>
            <br />
            <Link external url={URL['RecommendationWidgetsAbout']}>
              <Button>
                {i18n.translate(
                  'AdminHTML.Recommendation.GeneralSettings.HowToUse.button_LearnMore'
                )}
              </Button>
            </Link>
          </div>
        </div>
        <div className="banner-right">
          <div className="banner-dismiss" onClick={this.onDismiss}>
            <Icon source={CancelSmallMinor} />
          </div>
          <div className="banner-image"></div>
        </div>
      </div>
    ) : null;
  }

  // Get dismissed banner status
  checkDismissedBanner = () => {
    const shop = getShop();
    let dismissed = false;
    try {
      dismissed = localStorage.getItem(`${shop}-dismissBannerInRecommendGeneralSettingsPage`);
    } catch (error) {}

    if (dismissed === 'true') {
      this.setState({ dismissedBanner: true });
    }
  };

  // Handle hide banner
  onDismiss = () => {
    const shop = getShop();
    try {
      localStorage.setItem(`${shop}-dismissBannerInRecommendGeneralSettingsPage`, `true`);
    } catch (error) {}

    // Hide banner
    this.setState({ dismissedBanner: true });
  };
}

export default withI18n()(HowToUse);
